<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'

export default {
  name: 'App',
  components: { DefaultLayout, AuthLayout },
  computed: {
    layout() {
      return this.$route.meta.layout === 'auth' ? 'AuthLayout' : 'DefaultLayout'
    },
  },
}
</script>

<style>
html {
  overflow-y: auto !important;
}
</style>
